<template>
  <div style="display: flex; flex-direction: column; align-items: center">
    <div id="goz_esnetme">
      <div
        id="particles-js"
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0px;
          top: 0px;
        "
      ></div>
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <div
        v-if="start === false"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          z-index: 8988888;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 100%;
          height: 100%;
          background-color: white;
        "
      >
        <img
          src="/static/images/kartanesi/kardanadam.png"
          style="width: 160px"
        />
        <h1 style="font-size: 27px; font-weight: bold; margin-top: 20px">
          {{ $t("kar_title") }}
        </h1>
        <h2
          style="
            font-size: 17px;
            text-align: center;
            margin-top: 10px;
            margin-bottom: 20px;
          "
        >
          {{ $t("kar_desc") }}
        </h2>
        <el-button
          @click="
            start = true;
            registerTimeout();
            throwFlake();
          "
          >{{ $t("coursedetail.start") }}</el-button
        >
      </div>
      <div
        v-if="end === true"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          z-index: 8988888;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 100%;
          height: 100%;
          background-color: white;
        "
      >
        <img
          src="/static/images/kartanesi/kardanadam.png"
          style="width: 160px"
        />
        <h1 style="font-size: 27px; font-weight: bold; margin-top: 20px">
          Oyun Bitti!
        </h1>
        <h2
          style="
            font-size: 17px;
            text-align: center;
            margin-top: 10px;
            margin-bottom: 20px;
          "
        >
          Puanınız: {{ point }}
        </h2>
        <el-button
          @click="
            start = true;
            end = false;
            point = 0;
            level = 1;
            bottom = -500;
            throwFlake();
          "
          >TEKRAR BAŞLA</el-button
        >
      </div>
      <img
        src="/static/images/kartanesi/solagac.png"
        style="position: absolute; bottom: 0px; left: 0px; width: 200px"
      />
      <img
        src="/static/images/kartanesi/sagagac.png"
        style="position: absolute; bottom: 0px; right: 0px; width: 100px"
      />
      <img
        src="/static/images/kartanesi/kardanadam.png"
        style="position: absolute; bottom: 0px; left: 200px; width: 200px"
      />
      <div
        style="position: absolute; bottom: -500px; left: 0px; transition: 1s"
        :style="{ bottom: bottom + 'px' }"
      >
        <img src="/static/images/kartanesi/zemin.png" style="width: 100%" />
        <div
          style="
            width: 100%;
            height: 500px;
            margin-top: -20px;
            background-color: #dee1e2;
          "
        ></div>
      </div>

      <div
        class="flake"
        :style="{
          left: item.left + 'px',
          animationDuration: item.duration / 1000 + 's',
          animationPlayState: item.istrue === true ? 'paused' : 'running',
        }"
        :key="item.id"
        v-for="(item, index) in flakes"
      >
        {{ item.text }}
      </div>
    </div>

    <el-input
      @keyup.enter.native="check"
      v-if="start && end == false"
      style="
        width: 200px;
        height: 50px;
        border-radius: 10px;
        text-align: center;
        color: #333;
        margin-top: 10px;
        font-size: 27px;
        line-height: 50px;
      "
      v-model="answer"
      placeholder="Cevabınız"
    >
    </el-input>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
import "particles.js";
import { is } from "@amcharts/amcharts4/core";
import axios from "axios";
export default {
  name: "KarTanesi",
  props: ["config"],
  data() {
    return {
      pause: false,
      flakes: [],
      bottom: -500,
      answer: "",
      level: 1,
      levels: [
        {
          min: 18000,
        },
      ],
      lock: false,
      start: false,
      point: 0,
      end: false,
      matTimeout: null,
    };
  },
  created() {
    document.addEventListener("keydown", this.keypressed);
  },
  mounted() {
    particlesJS("particles-js", {
      particles: {
        number: {
          value: 400,
          density: {
            enable: true,
            value_area: 800,
          },
        },
        color: {
          value: "#ffffff",
        },
        shape: {
          type: "circle",
          polygon: {
            nb_sides: 5,
          },
          image: {
            src: "http://www.dynamicdigital.us/wp-content/uploads/2013/02/starburst_white_300_drop_2.png",
            width: 100,
            height: 100,
          },
        },
        opacity: {
          value: 0.3,
          random: false,
          anim: {
            enable: false,
            speed: 0.1,
            opacity_min: 0.1,
            sync: false,
          },
        },
        size: {
          value: 5,
          random: true,
          anim: {
            enable: false,
            speed: 20,
            size_min: 0.1,
            sync: false,
          },
        },
        line_linked: {
          enable: false,
          distance: 50,
          color: "#ffffff",
          opacity: 0.6,
          width: 1,
        },
        move: {
          enable: true,
          speed: 1,
          direction: "bottom",
          random: true,
          straight: false,
          out_mode: "out",
          bounce: false,
          attract: {
            enable: true,
            rotateX: 300,
            rotateY: 1200,
          },
        },
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: {
            enable: false,
            mode: "bubble",
          },
          onclick: {
            enable: false,
            mode: "repulse",
          },
          resize: true,
        },
        modes: {
          grab: {
            distance: 150,
            line_linked: {
              opacity: 1,
            },
          },
          bubble: {
            distance: 200,
            size: 40,
            duration: 2,
            opacity: 8,
            speed: 3,
          },
          repulse: {
            distance: 100,
            duration: 0.2,
          },
          push: {
            particles_nb: 4,
          },
          remove: {
            particles_nb: 2,
          },
        },
      },
      retina_detect: true,
    });
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keypressed);
    clearTimeout(this.matTimeout);
  },
  methods: {
    registerTimeout() {
      this.matTimeout = setTimeout(() => {
        axios.post("module/savePoints", {
          points: [
            {
              point: this.point,
              type: "matematik",
            },
          ],
          module_id: this.$store.state.modules.find(
            (k) => k.slug == "kar-tanesi"
          ).module_id,
        });
      }, 60000);
    },
    check(e) {
      if (this.end == true || this.start == false) return;
      var flakes = this.flakes.filter((k) => k.sonuc == parseInt(this.answer));

      if (flakes.length) {
        flakes.map((flake) => {
          var i = this.flakes.findIndex((k) => k.id == flake.id);
          if (i != -1) {
            this.flakes[i].istrue = true;
            clearTimeout(this.flakes[i].timeout);
            this.flakes[i].timeout = null;
            this.flakes.splice(i, 1);
          }
        });

        this.answer = "";
        this.level = Math.min(4, this.level + 1);

        this.point += this.level;
      }
    },

    throwFlake() {
      var y = 15000;
      let x = _.random(0, 956812832);
      let dur = _.random(15000 - this.level * 1000, 18000 - this.level * 1000);

      var isPlus = _.random(0, 1);

      var text = "";
      var sonuc = 0;

      if (isPlus === 1) {
        var n1 = _.random(1, 5);
        var n2 = _.random(1, 5);
        text = n1 + "+" + n2;
        sonuc = n1 + n2;
      }

      if (isPlus === 0) {
        var n1 = _.random(1, 5);
        var n2 = _.random(1, n1);
        text = n1 + "-" + n2;
        sonuc = n1 - n2;
      }

      var l = _.random(100, 650);

      while (true) {
        if (this.flakes.some((k) => l < k.left + 100 && l + 100 > k.left)) {
          l = _.random(100, 650);
        } else {
          break;
        }
      }

      this.flakes.push({
        left: l,
        duration: dur,
        text,
        istrue: false,
        timeout: setTimeout(() => {
          var index = this.flakes.findIndex((k) => k.id == x);
          this.flakes.splice(index, 1);
          this.bottom += 50;
        }, dur),
        id: x,
        sonuc,
      });
    },
  },
  watch: {
    "flakes.length": function () {
      if (this.lock) return;
      if (this.flakes.length < this.level) {
        this.lock = true;
        setTimeout(() => {
          for (
            let index = 0;
            index <= this.level - this.flakes.length;
            index++
          ) {
            this.throwFlake();
          }
          setTimeout(() => {
            this.lock = false;
          }, 200);
        }, 2500);
      }
    },
    bottom: function () {
      if (this.bottom == -300) {
        this.end = true;
        this.flakes.map((i, index) => {
          clearTimeout(this.flakes[index].timeout);
        });
        this.lock = true;
        this.flakes = [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 800px;
  max-width: 800px;
  height: 600px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  background-size: 100%;
  transform: rotateY(0deg);
  overflow: hidden;
  background: #97cef8 !important;
  background-position: bottom;
  background-size: cover;

  .flake {
    width: 100px;
    height: 100px;
    background: url(/static/images/kartanesi/tane.png);
    background-size: contain;
    position: absolute;
    top: -100px;
    left: 100px;
    background-repeat: no-repeat;
    background-position: center;
    color: orangered;
    font-size: 35px;
    font-weight: bold;
    text-align: center;
    line-height: 100px;
    animation: fall 20s linear;
  }

  @keyframes fall {
    from {
      top: -100px;
    }

    to {
      top: 700px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modules/KarTanesi.vue